import { atom } from "recoil";

export const DicDataPlaceState = atom({
  key: "DicDataPlaceState",
  default: {},
});
